import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class ChartOfAccQueryCriteriaClass extends BaseCriteriaModel {
  txn_type?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  descr?: Optional<string> = Optional.empty();
}

export class ChartOfAccCriteriaModelQuery {
  query = '';

  constructor(chartOfAccCriteriaModel: ChartOfAccQueryCriteriaClass) {

    if (!chartOfAccCriteriaModel) {
      return;
    }

    this.query += chartOfAccCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += chartOfAccCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += chartOfAccCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += chartOfAccCriteriaModel.descr.filter(x => x !== '').map(x => '&descr=' + x).orElse('');

    this.query += '&status=' + chartOfAccCriteriaModel.status;
    this.query += '&orderBy=' + chartOfAccCriteriaModel.orderBy;
    this.query += '&order=' + chartOfAccCriteriaModel.order;
    this.query += '&offset=' + chartOfAccCriteriaModel.offset + '&limit=' + chartOfAccCriteriaModel.limit;
  }
}
